export default [
  { to: 'rek_lm', title: 'Rek LM' },
  { to: 'barn', title: 'Barn rek' },
  { to: 'aldre', title: 'Äldre rek' },
  { to: 'halso', title: 'Hälso rek' },
  { to: 'om_lk', title: 'Nyheter' },
  { to: 'ovrigt', title: 'Övrigt' },
  { to: 'arkiv', title: 'Arkiv' },
];
